"use client";
import { jsx as r } from "react/jsx-runtime";
import * as i from "@radix-ui/react-radio-group";
import { twMerge as t } from "tailwind-merge";
const n = ({
  checked: o,
  ...e
}) => /* @__PURE__ */ r(
  i.Item,
  {
    "data-slot": "radio-group-item",
    checked: o,
    className: t(
      `
                w-4 h-4
                rounded-full
                border-2
                border-gray-300
                bg-white
                focus:outline-none
                focus:ring-blue-500
                focus:ring-1
                focus:ring-offset-2
            `,
      o && "outline-none ring-1 ring-offset-2 ring-blue-500 bg-blue-500 border-white"
    ),
    ...e,
    children: /* @__PURE__ */ r(i.Indicator, { "data-slot": "radio-group-indicator" })
  }
);
n.displayName = "RadioGroupItem";
export {
  n as RadioGroupItem
};
